import * as React from 'react';
import { ChipWrapper, ChipIcon, ChipText } from './styles.js';

const Chip = ({ className , $background , label , icon , ...rest })=>{
    return /*#__PURE__*/ React.createElement(ChipWrapper, {
        className: className,
        $background: $background,
        ...rest
    }, icon && /*#__PURE__*/ React.createElement(ChipIcon, null, icon), /*#__PURE__*/ React.createElement(ChipText, null, label));
};

export { Chip };
